import React from 'react'
import PropTypes from 'prop-types'

// import styles from './Footer.module.scss'

const Footer = ({
    children,
    purchaseLink,
    logo,
    twitterLink,
    instaLink,
    discordLink,
    twitter,
    discord,
    insta,
}) => (
    <div className="footer">
        <div className="wrapper">
            <div className="footerInfo">
                <div className="logo">
                    <a href={purchaseLink}>
                        {logo ? <img src={logo} alt={logo} /> : <h1>logo</h1>}
                    </a>
                </div>
                <div className="socialMedia">
                    <a href={discordLink}>
                        <img src={discord} alt="discord" />
                    </a>
                    <a href={twitterLink}>
                        <img src={twitter} alt="twitter" />
                    </a>
                    <a href={instaLink}>
                        <img src={insta} alt="instagram" />
                    </a>
                </div>
                <div className="nav">
                    <ul>
                        {children}
                    </ul>
                </div>
            </div>
            <div className="copyright">
                <p>&#169; copyright urbancoolab 2022</p>
            </div>
        </div>
    </div>
)
Footer.propTypes = {
    children: PropTypes.arrayOf(PropTypes.object).isRequired,
    logo: PropTypes.string.isRequired,
    purchaseLink: PropTypes.string.isRequired,
    discordLink: PropTypes.string.isRequired,
    instaLink: PropTypes.string.isRequired,
    twitterLink: PropTypes.string.isRequired,
    twitter: PropTypes.string.isRequired,
    insta: PropTypes.string.isRequired,
    discord: PropTypes.string.isRequired,
}

export default Footer
